import React from "react";
import { connect } from "react-redux";

import { APS_CANCEL_ORDER_MODAL } from "components/modals";
import {
  generateAPSOrderFiles,
  fetchInsured,
  fetchCaseFilesByCaseDocumentId,
  resetAPSOrderFiles,
  sendAPSCancellationFax,
  hideModal,
} from "actions";
import {
  activeCaseFileSelector,
  activeOrderFilesSelector,
  loadingSelector,
  insuredListSelector,
  doctorSelector,
  activeCaseSelector,
} from "reducers";
import File from "components/File";
import { Table } from "react-bootstrap";
import { FaFax } from "react-icons/fa";
import SimpleModal from "../../../../components/modals/SimpleModal";

const APSCancelOrderModal = ({ ...props }) => {
  let [sendingFax, setSendingFax] = React.useState(false);

  const SendButton = () => {
    let message;
    let errorMessage = "Fix errors before Sending";
    let errorFaxNumberMessage = "Please set Fax Number";
    if (sendingFax) {
      message = (
        <>
          Sending... <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
        </>
      );
    } else if (props.activeOrderFiles?.cancellation_file) {
      let faxNumber = "";
      let doctorInfo = {
        ...props.doctorInfo,
        ...props.activeCaseFile.doctor,
      };
      if (doctorInfo.fax) {
        faxNumber = `1-${doctorInfo.fax}`;
      }
      if (faxNumber) {
        message = (
          <>
            <FaFax />
            Send Fax ({faxNumber})
          </>
        );
      } else {
        message = errorFaxNumberMessage;
      }
    } else {
      message = (
        <>
          Generating... <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
        </>
      );
    }

    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn btn--secondary"
          onClick={async () => {
            setSendingFax(true);
            await props.sendAPSCancellationFax(props.activeCaseFile.id);
            await props.fetchCaseFilesByCaseDocumentId(props.activeCaseFile.id);
            props.hideModal(APS_CANCEL_ORDER_MODAL);
          }}
          style={{
            width: "50%",
            marginBottom: "1rem",
          }}
          disabled={message === errorMessage || message === errorFaxNumberMessage}
        >
          {message}
        </button>
      </div>
    );
  };

  const FileReview = () => {
    let apsCancelOrderFile = "";
    if (props.activeOrderFiles?.cancellation_file) {
      apsCancelOrderFile = <File style={{ marginBottom: 0 }} file={props.activeOrderFiles.cancellation_file} />;
    }
    return (
      <>
        <Table striped bordered hover>
          <div style={{ marginLeft: 10, padding: 15 }}>
            <h5>Instructions</h5>
            Please preview the file below. If everything looks correct, click 'Send Fax' to cancel the previously
            submitted order.
            <br />
          </div>
          {apsCancelOrderFile && (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 15 }}>
              {apsCancelOrderFile}
            </div>
          )}
        </Table>
        <SendButton />
      </>
    );
  };

  return (
    <SimpleModal modalType={APS_CANCEL_ORDER_MODAL} title={"APS Cancel Order"}>
      <FileReview />
    </SimpleModal>
  );
};

const mapStateToProps = state => {
  return {
    caseInfo: activeCaseSelector(state),
    activeCaseFile: activeCaseFileSelector(state),
    activeOrderFiles: activeOrderFilesSelector(state),
    insuredList: insuredListSelector(state),
    doctorInfo: doctorSelector(state),
    loading: loadingSelector(state),
  };
};

export default connect(mapStateToProps, {
  generateAPSOrderFiles,
  resetAPSOrderFiles,
  sendAPSCancellationFax,
  fetchInsured,
  fetchCaseFilesByCaseDocumentId,
  hideModal,
})(APSCancelOrderModal);
